<template>
  <div>
    <page-title></page-title>
    <!-- Table Container Card -->
    <b-card class="mt-1">
      <div class="mb-2">
        <b-row>
          <b-col cols="2">
            <b-form-input v-model="searchQuery" size="m" placeholder="搜索联系人" class="d-inline-block" />
          </b-col>
          <b-col offset="7" cols="3" class="d-flex justify-content-end align-items-center;">
            <b-button @click="addContactsModel" size="sm" variant="primary">
              <feather-icon icon="UserPlusIcon" />
              <span class="text-nowrap ml-1">{{ $t('addContacts') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-table
        :fields="fields"
        :items="contactsList"
        :busy="isBusy"
        :empty-text="$t('No Data')"
        sticky-header
        :no-border-collapse="true"
        show-empty
        style="max-height: 43rem"
        class="position-relative"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(actions)="data">
          <div class="align-middle text-center">
            <b-button class="btn-icon mr-1" size="sm" variant="warning" @click="editContactsModel(data)">
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button class="btn-icon" size="sm" variant="danger" @click="handleDelAlert(data.item.id)">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>

      <!-- <b-row>
        <b-col class="d-flex align-items-center justify-content-center justify-content-sm-start" cols="12" sm="6">
          <span class="text-muted small">{{
            `
						${$t('Show')}
						${dataMeta.from}
						${$t('to')}
						${dataMeta.to}
						${$t('of')}
						${dataMeta.of}
						${$t('Entries')}
						`
          }}</span>
        </b-col>
      </b-row> -->
    </b-card>
    <b-modal
      ref="modal"
      v-model="modelShow"
      ok-title="确定"
      cancel-title="取消"
      no-close-on-backdrop
      centered
      :title="modelTitle"
      @ok.prevent="handleOk"
      @hidden="handleCloseModal"
    >
      <form ref="formRef" autocomplete="off">
        <b-form-group label="姓名" label-for="nameInput" invalid-feedback="请填写姓名" :state="nameState">
          <b-form-input id="nameInput" ref="nameInput" v-model="form.name" :state="nameState" required></b-form-input>
        </b-form-group>
        <b-form-group label="手机号" label-for="phoneInput" invalid-feedback="请输入有效的11位中国大陆手机号" :state="phoneState">
          <b-form-input
            id="phoneInput"
            v-model="form.phone"
            :state="phoneState"
            type="text"
            pattern="^1[3-9]\d{9}$"
            required
            @keydown="handlePhoneKeyDown"
            @input="handlePhoneInput"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, ref, watch } from '@vue/composition-api';
import { showToast } from '@/libs/utils/showToast';
import { showConfirm } from '@/libs/utils/showConfirm';
import PageTitle from '@/views/layout/PageTitle';
import { getDiagnosisAlertList, addAlert, delAlert, editAlert } from '@/api/diagnosis';
import { routerParams } from '@/libs/utils/routerParams';

export default {
  components: {
    PageTitle,
  },
  setup() {
    const instance = getCurrentInstance().proxy;
    const fields = [
      {
        key: 'id',
        label: 'ID',
      },
      {
        key: 'name',
        label: '姓名',
      },
      {
        key: 'phone',
        label: '手机号',
      },
      {
        key: 'actions',
        label: '操作',
        thClass: 'actions-col',
        tdClass: 'actions-col',
      },
    ];
    const contactsList = ref([]);
    const modelShow = ref(false);
    const formRef = ref(null);
    const modelTitle = ref('');
    const searchQuery = ref('');
    const form = ref({
      name: '',
      phone: '',
    });
    const nameState = ref(null);
    const phoneState = ref(null);
    /**
     * 获取联系人列表
     */
    let originalData = [];
    const isBusy = ref(false);
    const fetchGetAlertList = () => {
      isBusy.value = true;
      getDiagnosisAlertList({
        project_id: routerParams('project_id'),
      })
        .then((res) => {
          originalData = res.data;
          contactsList.value = res.data;
        })
        .catch(() => {
          showToast(null, '提示', '获取联系人列表失败');
        })
        .finally(() => {
          isBusy.value = false;
        });
    };
    /**
     * 监听搜索框变化
     */
    watch(searchQuery, (newVal) => {
      if (newVal === '') {
        contactsList.value = [...originalData];
      } else {
        const query = newVal.toLowerCase();
        contactsList.value = originalData.filter((contact) => contact.name.toLowerCase().includes(query) || contact.phone.toString().includes(query));
      }
    });
    /**
     * 添加联系人模态框
     */
    const addContactsModel = () => {
      modelTitle.value = '添加联系人';
      modelShow.value = true;
    };
    /**
     * 处理手机输入的keydown事件
     */
    const handlePhoneKeyDown = (event) => {
      // 允许控制键
      const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Meta', 'Control', 'Alt'];
      // 允许数字键
      const isNumberKey = event.key >= '0' && event.key <= '9';
      const isNumpadKey = event.key.startsWith('Digit') || event.key.startsWith('Numpad');
      // 阻止非数字输入
      if (!isNumberKey && !isNumpadKey && !allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
      // 限制长度为11位
      if (event.key !== 'Backspace' && event.key !== 'Delete' && form.value.phone.length >= 11) {
        event.preventDefault();
      }
    };
    /**
     * 处理手机输入
     */
    const handlePhoneInput = () => {
      // 过滤非法字符（处理粘贴等情况）
      form.value.phone = form.value.phone.replace(/[^0-9]/g, '');

      // 限制长度
      if (form.value.phone.length > 11) {
        form.value.phone = form.value.phone.slice(0, 11);
      }
      // 验证格式
      validatePhone();
    };
    /**
     * 验证手机号格式
     */
    const validatePhone = () => {
      if (!form.value.phone) {
        phoneState.value = null;
        return;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      phoneState.value = phoneRegex.test(form.value.phone);
    };
    /**
     * 处理联系人操作
     * @param {Function} apiCall - API 调用函数
     * @param {Object} data - 请求数据
     * @param {string} message - 成功消息
     */
    const handleContactOperation = (apiCall, data, message) => {
      apiCall(data)
        .then((res) => {
          if (res.status === 200) {
            showToast(null, message, message);
            modelShow.value = false;
            fetchGetAlertList(true); // 保留搜索状态
          }
        })
        .catch((error) => {
          showToast(error, '操作失败', '请检查输入信息');
        });
    };
    /**
     * 删除联系人
     * @param id
     */
    const handleDelAlert = (id) => {
      showConfirm(instance, '确认删除?', () => {
        const params = {
          project_id: routerParams('project_id'),
          id: [id],
        };
        delAlert(params)
          .then((response) => {
            console.log('删除用户');
            if (response) {
              showToast(null, '删除完成', '您已成功删除该用户');
              fetchGetAlertList();
            }
          })
          .catch((error) => {
            showToast(error);
          });
      });
    };
    /**
     * 修改联系人弹窗
     * @param item 联系人信息
     */
    const id = ref(null);
    const editContactsModel = (item) => {
      console.log('item:', item);
      modelTitle.value = '修改联系人';
      id.value = item.item.id;
      form.value.name = item.item.name;
      form.value.phone = item.item.phone;
      modelShow.value = true;
    };
    /**
     * 验证表单
     */
    const checkFormValidity = () => {
      const valid = formRef.value.checkValidity();
      nameState.value = valid;
      phoneState.value = valid;
      return valid;
    };
    /**
     * 提交表单
     */
    const handleOk = () => {
      if (!checkFormValidity()) {
        return;
      }
      const data = {
        project_id: routerParams('project_id'),
        name: form.value.name,
        phone: form.value.phone,
      };
      if (modelTitle.value === '添加联系人') {
        handleContactOperation(addAlert, data, '添加成功');
      } else {
        handleContactOperation(editAlert, { ...data, id: id.value }, '修改成功');
      }
    };
    /**
     * 关闭模态框后处理
     */
    const handleCloseModal = () => {
      form.value.name = '';
      form.value.phone = '';
      nameState.value = null;
      phoneState.value = null;
    };
    onMounted(() => {
      fetchGetAlertList();
    });
    return {
      searchQuery,
      isBusy,
      fetchGetAlertList,
      fields,
      contactsList,
      formRef,
      modelShow,
      modelTitle,
      form,
      handlePhoneKeyDown,
      handlePhoneInput,
      nameState,
      phoneState,
      addContactsModel,
      editContactsModel,
      handleOk,
      handleCloseModal,
      handleDelAlert,
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .actions-col {
  width: 200px !important;
  max-width: 200px !important;
  text-align: center;
}
</style>
